module.exports = __webpack_public_path__ + "任煜男-2e8a9163.png";